<template>
  <nav v-if="!isMobile()" class="navbar navbar-expand-lg nav-ds" role="navigation">
    <div class="container-fluid">
      <router-link class="navbar-brand" to="/welcome">
        <img :src="erriffHealthLogo" alt="Erriff Health" class="brand-logo" />
      </router-link>
      <span v-if="displayEnvironmentName" class="deploy-env-badge">{{ environmentName }}</span>
      <router-link class="icon__btn home" to="/welcome">Home</router-link>
      <button
        v-if="viewingPatientChart"
        class="icon__btn revert"
        @click.prevent="revert"
      >
        Back to Dashboard 
      </button>
      <!-- Desktop only: centered "Viewing: Name (DOB)" while in a patient chart.
           Mobile counterpart is .mobile-viewing in the header below. -->
      <span
        v-if="viewingPatientChart && viewingPatientLabel"
        class="original-user-info"
      >
        Viewing: {{ viewingPatientLabel }}
      </span>
      <!-- <button
        v-if="viewingPatientChart && !invited"
        class="icon__btn invite"
        @click.prevent="invite"
      >
        Invite
      </button>
      <button
        v-if="viewingPatientChart && invited"
        class="icon__btn uninvite"
        @click.prevent="uninvite"
      >
        Uninvite
      </button> -->
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span><font-awesome-icon :icon="['fas', 'bars']" class="icon" /></span>
      </button>

      <div class="collapse navbar-collapse flex-column" id="navbarSupportedContent">
        <!-- upper nav -->
        <navigation-bar-top></navigation-bar-top>

        <!-- lower nav -->
        <navigation-bar-bottom></navigation-bar-bottom>
      </div>
    </div>
  </nav>
  <div v-else class="mobile-main nav-ds" :class="{ 'mobile-main--menu-open': mobileMenuOpen }">
    <div class="mobile-header">
      <div class="mobile-header-left">
        <router-link to="/welcome" class="mobile-header-item">
          <img :src="erriffHealthLogo" alt="Erriff Health" class="brand-logo brand-logo--mobile" />
        </router-link>
        <span v-if="displayEnvironmentName" class="deploy-env-badge deploy-env-badge--mobile">{{ environmentName }}</span>
      </div>
      <div class="mobile-header-name">
        {{ displayUserName }}
        <!-- Mobile only: "Viewing: Name (DOB)" while in a patient chart.
             Desktop counterpart is .original-user-info in the navbar above. -->
        <template v-if="viewingPatientChart && viewingPatientLabel">
          <br />
          <span class="mobile-viewing">Viewing: {{ viewingPatientLabel }}</span>
        </template>
      </div>
      <div class="mobile-header-icons">
        <font-awesome-icon v-if="viewingPatientChart" :icon="['fas', 'phone']" />
        <font-awesome-icon
          v-if="viewingPatientChart"
          @click="sendText"
          :icon="['fas', 'comment-dots']"
        />
        <!-- stopPropagation so the document outside-click handler does not instantly re-close. -->
        <font-awesome-icon @click.stop="showMenu" :icon="['fas', 'bars']" />
                  </div>
          </div>
          
          <div
            class="dropdown-menu"
            id="dropdown-menu"
            :class="{ show: mobileMenuOpen }"
            v-show="mobileMenuOpen"
            @click.stop
          >
      <ul>
        <li class="menu-item">
          <base-link :to="'/welcome'" @click="closeNav">Home</base-link>
        </li>
        <li v-if="!viewingPatientChart" class="menu-item">
          <router-link to="/user/profile" @click="closeNav">Profile</router-link>
        </li>
        <li v-if="!viewingPatientChart" class="menu-item">
          <router-link to="/user/contact" @click="closeNav">Contact</router-link>
        </li>
        <li v-if="!viewingPatientChart" class="menu-item">
          <router-link to="/user/devices" @click="closeNav">Devices</router-link>
        </li>
        <li v-if="canReadDirectives" class="menu-item">
          <router-link to="/directives" @click="closeNav"
            >Directives<directives-nav-badge
          /></router-link>
        </li>
        <li v-if="!administrator" class="menu-item" :class="{ open: openSubmenu === 'current' }">
          <a href="#" class="submenu-toggle" @click.prevent="toggleSubmenu('current')">Current</a>
          <ul class="submenu">
            <li>
              <base-link :to="'/vitalsGroup/all'" @click="closeNav">Vitals</base-link>
            </li>
            <li>
              <base-link :to="'/currentProviders'" @click="closeNav">Providers</base-link>
            </li>
            <li>
              <base-link :to="'/currentProcedures'" @click="closeNav"
                >Procedures</base-link
              >
            </li>
            <li>
              <base-link :to="'/currentDiagnosis'" @click="closeNav">Diagnoses</base-link>
            </li>
            <li>
              <base-link :to="'/currentMedications'" @click="closeNav"
                >Medications</base-link
              >
            </li>
          </ul>
        </li>
        <li v-if="!administrator" class="menu-item">
          <router-link to="/allergy" @click="closeNav">Allergies</router-link>
        </li>
        <li v-if="!administrator" class="menu-item" :class="{ open: openSubmenu === 'historical' }">
          <a href="#" class="submenu-toggle" @click.prevent="toggleSubmenu('historical')">Historical</a>
          <ul class="submenu">
            <li>
              <router-link to="/providers" @click="closeNav">Providers</router-link>
            </li>
            <li>
              <router-link to="/procedureKinds" @click="closeNav">Procedures</router-link>
            </li>
            <li>
              <router-link to="/labKinds" @click="closeNav">Labs</router-link>
            </li>
            <li>
              <router-link to="/diagnosis" @click="closeNav">Diagnoses</router-link>
            </li>
            <li>
              <router-link to="/medication" @click="closeNav">Medications</router-link>
            </li>
            <li>
              <router-link to="/vaccination" @click="closeNav">Vaccinations</router-link>
            </li>
          </ul>
        </li>
        <!-- Reports sits between Historical and CDAs (same order as desktop lower nav). -->
        <li v-if="!administrator" class="menu-item">
          <router-link to="/reports" @click="closeNav">Reports</router-link>
        </li>
        <li v-if="!administrator" class="menu-item">
          <router-link to="/cdas" @click="closeNav">CDAs</router-link>
        </li>
        <li v-if="!administrator" class="menu-item">
          <router-link to="/pdfs" @click="closeNav">PDFs</router-link>
        </li>
        <li v-if="!administrator" class="menu-item" :class="{ open: openSubmenu === 'data' }">
          <a href="#" class="submenu-toggle" @click.prevent="toggleSubmenu('data')">Data</a>
          <ul class="submenu">
            <li>
              <base-link :to="'/data-upload'" @click="closeNav">Upload Data</base-link>
            </li>
            <li>
              <base-link :to="'/watch'" @click="closeNav">Trend Labs</base-link>
            </li>
          </ul>
        </li>
        <li v-if="!administrator" class="menu-item" :class="{ open: openSubmenu === 'remote' }">
          <a href="#" class="submenu-toggle" @click.prevent="toggleSubmenu('remote')">Remote Monitoring</a>
          <ul class="submenu">
            <li>
              <base-link :to="'/user/devices'" @click="closeNav">Devices</base-link>
            </li>
            <li><base-link :to="'/cpt'" @click="closeNav">CPT</base-link></li>
            <li v-if="viewingPatientChart">
              <router-link to="/user/contact" @click="closeNav">Contacts</router-link>
            </li>
          </ul>
        </li>
       
        <li v-if="administrator" class="menu-item">
          <router-link to="/currentNurse" @click="closeNav">Nurses</router-link>
        </li>
        <li v-if="administrator" class="menu-item">
          <router-link to="/patients" @click.native="closeNav">Patients</router-link>
        </li>
        <li v-if="administrator" class="menu-item">
          <router-link to="/professional-notes" @click="closeNav">Notes</router-link>
        </li>
        <li v-if="administrator" class="menu-item">
          <a href="#" @click.prevent="openBillingNav">Billing</a>
        </li>
        <li v-if="viewingPatientChart" class="menu-item">
          <a @click="closeNav(); revert()">Back to Dashboard</a>
        </li>
        <li class="menu-item">
          <a @click="handleLogout">Log Out</a>
        </li>
      </ul>
    </div>
    <!-- <div v-if="openMobileText" id="mobile-text-modal" class="mobile-text-modal">
      <div class="inner-mobile-modal">
        <label>Enter text body</label>
        <input type="text" required v-model="mobileTxt" class="form-control2" />
      </div>
      <div class="btn-group">
        <button type="submit" class="btn btn-primary">Send</button>
        <button type="button" class="btn btn-secondary">Cancel</button>
      </div>
    </div> -->
  </div>
</template>

<script>
import BaseLink from "./BaseLink.vue";
import { mapGetters, mapActions } from "vuex";
import NavigationBarTop from "./NavigationBarTop";
import NavigationBarBottom from "./NavigationBarBottom";
import DirectivesNavBadge from "./DirectivesNavBadge.vue";
import { exitPatientChart, invitePatient, uninvitePatient } from "@/api/sessionApi";
import { isViewingPatientChart, getInvited, getAdministrator } from "@/data/getters";
import { post } from "@/store/modules/fsm/index";
import { LogoutRequest } from "@/store/modules/fsm/messages";
import { h } from "vue";
import { PRIVILEGES } from "@/constants/privileges";
import { assertPrivilegeOrAlert } from "@/utils/privilegeGate";
import { usePrivilegesStore } from "@/stores/privileges";
import { useSessionSelfStore } from "@/stores/sessionSelf";
import { mapState } from "pinia";
import { chromeDisplayNameFrom } from "@/utils/sessionIdentity";
import erriffHealthLogo from "@/assets/images/erriff-health-logo.svg";

export default {
  name: "navigation-bar",
  
  mounted() {
    console.log('NavigationBar mounted!');
    // Close hamburger when tapping the page behind the menu.
    document.addEventListener("click", this.handleDocumentClick);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleDocumentClick);
  },
  
  watch: {
    // Navigating to another page should dismiss the hamburger menu.
    $route() {
      this.closeNav();
    },
  },
  
  data() {
    return {
      erriffHealthLogo,
      openMobileText: false,
      mobileTxt: "",
      openSubmenu: null,
      mobileMenuOpen: false,
    };
  },
  components: {
    "navigation-bar-top": NavigationBarTop,
    "navigation-bar-bottom": NavigationBarBottom,
    "base-link": BaseLink,
    "directives-nav-badge": DirectivesNavBadge,
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
      user: "getUser",
    }),
    // Options API: mapState so the mobile header name updates when MySQL self loads.
    ...mapState(useSessionSelfStore, {
      sessionSelfProfile: "profile",
    }),
    viewingPatientChart: function () {
      return isViewingPatientChart(this.allData);
    },
    invited: function () {
      return getInvited(this.allData);
    },
    administrator: function () {
      return getAdministrator(this.allData);
    },
    canReadDirectives() {
      return usePrivilegesStore().effectiveGranted(PRIVILEGES.DIRECTIVE_READ);
    },
    displayEnvironmentName() {
      return process.env.VUE_APP_DISPLAY_ENVIRONMENT_NAME === "true";
    },
    environmentName() {
      return process.env.VUE_APP_ENVIRONMENT_NAME;
    },
    /** Top-right / mobile header name: stay as the real logged-in user while in a chart. */
    displayUserName() {
      // MySQL only — never show stale Postgres names before GetSelfProfile.
      return chromeDisplayNameFrom(this.sessionSelfProfile);
    },
    /** Patient being charted: "First Last (DOB)" for the Viewing: label. */
    viewingPatientLabel() {
      const first = this.user?.firstName || "";
      const last = this.user?.lastName || "";
      const name = `${first} ${last}`.trim();
      if (!name) return "";
      const dob = this.user?.dob ? ` (${this.user.dob})` : "";
      return `${name}${dob}`;
    },
  },
  methods: {
    ...mapActions("login", ["updateApplicationModel"]),
    sendText() {},
    showMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      if (!this.mobileMenuOpen) this.openSubmenu = null;
    },
    // Any click that reaches document (outside menu / hamburger) closes the menu.
    handleDocumentClick() {
      if (this.mobileMenuOpen) this.closeNav();
    },
    toggleSubmenu(key) {
      this.openSubmenu = this.openSubmenu === key ? null : key;
    },
    handleLogout() {
      post({ message: LogoutRequest });
    },
    openBillingNav() {
      this.closeNav();
      if (
        !assertPrivilegeOrAlert(
          PRIVILEGES.VIEW_USE_BILLING_PAGE,
          "You do not have permission to view the billing page."
        )
      ) {
        return;
      }
      this.$router.push("/cptBilling");
    },
    closeNav() {
      this.mobileMenuOpen = false;
      this.openSubmenu = null;
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    revert: function () {
      const loader = this.$loading.show(
        {},
        {
          after: () => h("div", {}, "Reverting back..."),
        }
      );

      exitPatientChart()
        .then(() => {
          return this.updateApplicationModel();
        })
        .then(() => {
          window.location.hash = "welcome"; //KW Updated this so that after exiting the patient chart, routing (with new router logic will work and not be on a blank white page)
          window.location.reload();
        })
        .catch((err) => {
          console.error(err);
          this.$toast.add({
            severity: "error",
            summary: "Revert failed",
            detail: err,
            life: 3000,
          });
        })
        .finally(() => {
          loader.hide();
        });
    },

    invite: function () {
      invitePatient().then(() =>
        setTimeout(() => {
          window.location.reload();
        }, 1000)
      );
    },
    uninvite: function () {
      uninvitePatient().then(() =>
        setTimeout(() => {
          window.location.reload();
        }, 1000)
      );
    },
  },
};
</script>

<style scoped lang="scss">
$color-base: #0060ff;
$color-font: #fff;

.deploy-env-badge {
  margin-left: 0.5rem;
  padding: 0.15rem 0.45rem;
  font-size: 3rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: white;
  background: #cb5f50;
  border-radius: 4px;
  vertical-align: middle;

  &--mobile {
    margin-left: 0.35rem;
    font-size: 0.6rem;
  }
}

.navbar {
  z-index: -10;
  color: #fff;
  /* Solid brand fill — no gradient / photo fade (EHR clarity) */
  background: #24555b !important;
  background-image: none !important;
}

.icon__btn {
  background-color: #4b9ca5;
  border-radius: 4px;
  border: none;
  margin: 10px;
  color: #fff;
  font-family: "Inter", system-ui, sans-serif;
  font-weight: 600;
}

.icon__btn.home {
  color: #fff;
  padding: 8px 16px;
  text-decoration: none;
  display: inline-block;
}

.icon__btn.revert {
  color: #fff;
  padding: 8px 16px;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
}

.navbar-brand {
  color: $color-font;
  display: flex;
  align-items: center;
  padding: 0;
}

.brand-logo {
  height: 65px;
  width: auto;
  display: block;

  &--mobile {
    height: 44px;
  }
}

.navbar-collapse {
  line-height: 1rem;
  padding-top: 0.3rem;
}

.navbar-toggler {
  color: #fff;
}

body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  background-color: #f7f7f7;
}

.navbar {
  display: flex;
  // justify-content: flex-end;
  align-items: center;
  padding: 10px 20px;
  /* background kept on the gradient rule above — do not force white */
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);

  > .container-fluid {
    position: relative;
    /* Top-align brand / Home / Viewing / upper nav so "Viewing:" shares the
       same vertical plane as Directives / Help / name (not mid-bar). */
    align-items: flex-start;
  }
}

.menu-icon {
  cursor: pointer;
}

.menu-icon div {
  width: 25px;
  height: 3px;
  background-color: #333;
  margin: 5px 0;
  transition: all 0.3s ease;
}

.dropdown-menu {
  /* Visibility is controlled by v-show (mobileMenuOpen), not display:none here. */
  position: absolute;
  top: 60px; /* adjust as needed */
  right: 0;
  width: 250px;
  max-width: min(250px, 100vw);
  background-color: #fff;
  border: 1px solid #ddd;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  /* Above HelpModal (.help-shell at 2000100). */
  z-index: 2000500;
}

.mobile-main {
  position: sticky;
  top: 0;
  z-index: 2000500;
  width: 100%;
  /* Opaque so page content does not show through while stuck. */
  background-color: #24555b;
}

.mobile-main--menu-open {
  z-index: 2000500;
}

.dropdown-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.dropdown-menu .menu-item {
  border-bottom: 1px solid #ddd;
}

.menu-item a {
  display: block;
  padding: 15px 20px;
  text-decoration: none;
  color: #333;
}

.dropdown-menu .menu-item a:hover {
  background-color: #f1f1f1;
}

.dropdown-menu .submenu {
  display: none;
  padding-left: 20px;
}

.menu-item.open > .submenu {
  display: block;
}

.submenu-toggle {
  cursor: pointer;
}

.nameTag {
  color: white;
  margin-right: 15%;
}

.mobile-brand {
  font-size: 100%;
}

.mobile-header-item {
  color: white;
  text-decoration: none;
  background: none;
  border: none;
  padding: 0;
}

.mobile-header {
  background-color: #24555b;
  color: white;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.mobile-header-left {
  display: flex;
  flex-direction: column;
}

.mobile-divider {
  height: 1px;
  background-color: white;
  width: 50px;
  margin: 5px 0;
}

.mobile-header-name {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  word-wrap: break-word;
}

.mobile-viewing {
  font-size: 12px;
  font-weight: normal;
  display: inline-block;
  margin-top: 2px;
}

.mobile-header-icons {
  font-size: 20px;
  display: flex;
  gap: 10px;
}

.original-user-info {
  position: absolute;
  left: 50%;
  /* Same top padding as NavigationBarTop .nav-link so the label sits on that row. */
  top: 0.25rem;
  transform: translateX(-50%);
  z-index: 2;
  display: flex;
  align-items: center;
  color: $color-font;
  margin: 0;
  padding: 0.25rem 0.5rem;
  font-size: 0.95rem;
  font-family: "Noto Sans", system-ui, sans-serif;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  text-align: center;
  pointer-events: none;
  max-width: min(42vw, 28rem);
  overflow: hidden;
  text-overflow: ellipsis;
}

// .mobile-main {
//   padding: 10px;
// }
</style>
